// extracted by mini-css-extract-plugin
module.exports = {"container":"TitleSection_container__38H8V","title":"TitleSection_title__3jqXQ","subTitle":"TitleSection_subTitle__3WHhl","logo":"TitleSection_logo__2YHGJ"};